<p>Login component works</p>